import { DaymapQuery as a } from "../daymapQuery.js";
var l;
((t) => {
  class r extends a {
    constructor() {
      super(
        ["settings"],
        null,
        "/lms/api/settings/clientsettings",
        null,
        { stale: 1e3 * 60 * 5 }
      );
    }
  }
  t.get = r;
  class m extends a {
    constructor(s, e) {
      super(
        ["DaymapTheme", s, e],
        { schoolCode: s, contactId: e },
        `/lms/api/theme/default/light?schoolCode=${s}&redirectUri=&${e ? `contactId=${e}` : ""}`,
        null,
        { stale: 1e3 * 60 * 60 * 6 }
      );
    }
  }
  t.DaymapTheme = m;
})(l || (l = {}));
export {
  l as settings
};
//# sourceMappingURL=index.js.map
